type LogLevel = 'debug' | 'info' | 'warn' | 'error'

export interface LogEntry {
  level: LogLevel
  message: string
  timestamp: string
  context?: Record<string, unknown>
}

const LOG_KEY = 'trevahhh-logs-v1'
const MAX_LOGS = 300

function readLogs(): LogEntry[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(LOG_KEY) || '[]') as unknown
    return Array.isArray(parsed) ? parsed.slice(-MAX_LOGS) as LogEntry[] : []
  } catch {
    return []
  }
}

export function log(level: LogLevel, message: string, context?: Record<string, unknown>): void {
  const entry: LogEntry = { level, message, timestamp: new Date().toISOString(), context }
  const logs = [...readLogs(), entry].slice(-MAX_LOGS)
  localStorage.setItem(LOG_KEY, JSON.stringify(logs))
  if (level === 'error') console.error(message, context ?? {})
  else if (level === 'warn') console.warn(message, context ?? {})
  else console.info(message, context ?? {})
}

export const logger = {
  debug: (message: string, context?: Record<string, unknown>) => log('debug', message, context),
  info: (message: string, context?: Record<string, unknown>) => log('info', message, context),
  warn: (message: string, context?: Record<string, unknown>) => log('warn', message, context),
  error: (message: string, context?: Record<string, unknown>) => log('error', message, context),
  entries: readLogs,
  clear: () => localStorage.removeItem(LOG_KEY)
}
